module.exports = __webpack_public_path__ + "static/media/ramanujan.f4766b4e.png";